import { IPcr } from '../../../features/pcr/store/pcr.types'
import { initialAddPnProcedure } from '../../../features/procedures/pnProcedure/store/pnProcedure.reducers'
import Logger from '../../../services/logger.service'
import { cloneDeep } from 'lodash'

export const pnProcedure = (pcr: any): IPcr => {
  const options = [
    {
      id: 8801001,
      name: 'Contraindication Noted',
      nemsisCode: 8801001,
      isNV: false,
      isPN: true,
    },
    {
      id: 8801003,
      name: 'Denied By Order',
      nemsisCode: 8801003,
      isNV: false,
      isPN: true,
    },
    {
      id: 7701001,
      name: 'Not Applicable',
      nemsisCode: 7701001,
      isNV: true,
      isPN: false,
    },
    {
      id: 7701003,
      name: 'Not Recorded',
      nemsisCode: 7701003,
      isNV: true,
      isPN: false,
    },
    {
      id: 8801027,
      name: 'Order Criteria Not Met',
      nemsisCode: 8801027,
      isNV: false,
      isPN: true,
    },
    {
      id: 8801019,
      name: 'Refused',
      nemsisCode: 8801019,
      isNV: false,
      isPN: true,
    },
    {
      id: 8801023,
      name: 'Unable to Complete',
      nemsisCode: 8801023,
      isNV: false,
      isPN: true,
    },
  ]
  const getPNNVCode = (code: number) => {
    const obj = {
      pn: '',
      nv: '',
    }
    const option = options.find((option) => option.id === code)
    if (option) {
      obj.pn = option.isPN ? String(code) : ''
      obj.nv = option.isNV ? String(code) : ''
    }
    return obj
  }
  try {
    if (!pcr.patient.procedureTypeStateListPNNVs && pcr.patient.patientVitals_pertNegProcs) {
      const pcrUpdated = cloneDeep(pcr)
      pcrUpdated.patient.procedureTypeStateListPNNVs = pcrUpdated.patient.patientVitals_pertNegProcs.map(
        (mainItem: any) => {
          const { pertNegProcs, ...remainingItems } = mainItem
          const newMainItem = cloneDeep(initialAddPnProcedure)
          newMainItem.id = mainItem.pnProcedure.id
          newMainItem.date = mainItem.date
          newMainItem.time = mainItem.time
          newMainItem.pta = mainItem.pta
          newMainItem.nemsisCode = String(mainItem.pnProcedure.procId.id)
          newMainItem.nemsisCodePNNV = getPNNVCode(mainItem.pnProcedure.code)
          remainingItems.pnProcedure = newMainItem
          return {
            ...remainingItems,
            procedurePNNVs: mainItem.pertNegProcs.map((item: any) => {
              const newProcItem = cloneDeep(initialAddPnProcedure)
              newProcItem.id = item.id
              newProcItem.date = mainItem.date
              newProcItem.time = mainItem.time
              newProcItem.pta = mainItem.pta
              newProcItem.nemsisCode = String(item.procId.id)
              newProcItem.nemsisCodePNNV = getPNNVCode(item.code)
              return newProcItem
            }),
          }
        }
      )
      delete pcr.patient.patientVitals_pertNegProcs
      pcr.patient.procedureTypeStateListPNNVs = pcrUpdated.patient.procedureTypeStateListPNNVs
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule pnProcedure ${error}`)
    throw error
  }
}
